import { useState, useEffect } from 'react';
import { X, Cookie } from 'lucide-react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Small delay for better UX
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 animate-in slide-in-from-bottom duration-500"
      data-testid="cookie-consent-banner"
    >
      <div className="bg-gray-900 border-t-4 border-orange-500 shadow-2xl">
        <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            {/* Icon and Text */}
            <div className="flex items-start sm:items-center gap-3 flex-1">
              <div className="bg-orange-500 p-2 rounded-lg shrink-0">
                <Cookie className="w-5 h-5 text-white" />
              </div>
              <p className="text-gray-300 text-sm sm:text-base">
                We use cookies to enhance your browsing experience and analyse our traffic. 
                By clicking "Accept All", you consent to our use of cookies.{' '}
                <a 
                  href="/contact" 
                  className="text-orange-400 hover:text-orange-300 underline transition-colors"
                >
                  Learn more
                </a>
              </p>
            </div>

            {/* Buttons */}
            <div className="flex items-center gap-3 shrink-0">
              <button
                onClick={declineCookies}
                className="px-4 py-2 text-sm font-medium text-gray-400 hover:text-white border border-gray-600 hover:border-gray-500 rounded-lg transition-all duration-200"
                data-testid="cookie-decline-btn"
              >
                Decline
              </button>
              <button
                onClick={acceptCookies}
                className="px-5 py-2 text-sm font-medium text-white bg-orange-500 hover:bg-orange-600 rounded-lg transition-all duration-200 shadow-lg hover:shadow-orange-500/25"
                data-testid="cookie-accept-btn"
              >
                Accept All
              </button>
              <button
                onClick={declineCookies}
                className="p-1 text-gray-500 hover:text-white transition-colors sm:hidden"
                aria-label="Close cookie banner"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
